<template>
  <div class="inner-header experiment bg-blue">
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-3 col-xs-12">
          <div class="logo pull-left">
            <a href="#">
              <router-link to="/">
              <img src="../assets/logo.png">
              </router-link></a>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 pull-right">
          <ul class="main-navigation add">
            <LoginLogout style="line-height: 36px" :background="'white'"></LoginLogout>
            <li><a style="display: none" data-toggle="modal" data-target="#about" class="btn-header white button hoverable" href="#"><div class="anim"></div>How to use</a></li>
            <how-popup></how-popup>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HowPopup from './howPopup'
import LoginLogout from './LoginLogout'

export default {
  components: {LoginLogout, HowPopup},
  name: 'InnerHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/innerHeader.vue